const Map = () => {
  return (
    <>
    <div className="text-center mt-[2rem] md:mt-[4rem]">
      <h2 className="text-[32px] font-semibold mb-3">Locate Us</h2>
      
      <div className="text-center px-[25.9px] text-black mx-auto md:w-[40%] mb-[3rem]">
        <p>We’re here to help! Use the map below to find our headquarters. Our team is ready to assist you with any inquiries or support you may need.</p>
      </div>
    </div>
    <iframe 
      src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15228.404107111688!2d7.411400921809833!3d9.112733853676842!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x104e750c10f4e05f%3A0xaaf486ef52d3055c!2sSmash%20Technology%20Nigeria!5e0!3m2!1sen!2sng!4v1734024734016!5m2!1sen!2sng"
      width="100%" 
      height="800" 
      style={{ border: 0, allowfullscreen: "", loading: "lazy", referrerpolicy: "no-referrer-when-downgrade" }}></iframe>
    </>
  )
}
export default Map;